import styled from 'styled-components';

export const FooterWrapper = styled.div`
	margin-top: 100px;
	border-top: 1px solid #eee;
	background: #f5f5f5;

	.dim {
		display: block;
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
	.wrapper {
		max-width: 1245px;
		width: 100%;
		padding: 60px 20px 100px 20px;
		margin: 0 auto;
		.top {
			display: flex;
			justify-content: space-between;
			.footer-logo {
				width: 120px;
				img {
					width: 100%;
				}
			}
			.select-wrap {
				position: relative;
				cursor: pointer;
				z-index: 88;
				img {
					cursor: pointer;
					margin-left: 4px;
					position: relative;
					left: -4px;
					top: -2px;
				}
				.logo-title {
					font-size: 16px;
					font-weight: 500;
					line-height: normal;
					margin-right: 10px;
				}
				.toggle-menu {
					border-radius: 10px;
					border: 1px solid #eee;
					background: #fff;
					padding: 6px 30px 22px 22px;
					height: 194px;
					overflow-y: auto;
					position: absolute;
					width: 150px;
					right: 6px;
					bottom: 39px;
					&::-webkit-scrollbar {
						width: 3px;
					}
					&::-webkit-scrollbar-thumb {
						background: rgba(0, 0, 0, 0.2);
						border-radius: 20px;
					}

					li {
						margin-top: 16px;
						color: #666;
						font-size: 14px;
						font-style: normal;
						font-weight: 400;
						line-height: normal;
						transition: all 0.3s;
						&:hover {
							opacity: 0.8;
						}
					}
				}
			}
		}
		.under {
			margin-top: 39px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			ul {
				display: flex;
				gap: 30px;
				li {
					font-size: 16px;
					font-weight: 500;
					line-height: normal;
				}
				.social {
					color: #666;
				}
			}
			.copy {
				color: #666;
				font-size: 15px;
				font-weight: 300;
				line-height: normal;
			}
		}
	}
	@media screen and (max-width: 768px) {
		margin-top: 60px;
		.wrapper {
			padding: 50px 30px 70px 30px;
			.top {
				.footer-logo {
					width: 100px;
					img {
						width: 100%;
					}
				}
				.select-wrap {
					position: relative;
					img {
						margin-left: 8px;
						position: relative;
						left: -4px;
						top: -2px;
					}
					.logo-title {
						font-size: 14px;
						margin-right: 8px;
					}
					.toggle-menu {
						border-radius: 10px;
						border: 1px solid #eee;
						background: #fff;
						padding: 6px 30px 22px 22px;
						height: 194px;
						overflow-y: auto;
						position: absolute;
						width: 150px;
						right: 6px;
						bottom: 39px;
					}
				}
			}
			.under {
				margin-top: 40px;
				width: 100%;
				flex-direction: column;
				align-items: start;
				ul {
					gap: 8px 20px;
					flex-wrap: wrap;
					li {
						font-size: 14px;
					}
				}
				.copy {
					font-size: 13px;
					margin-top: 18px;
				}
			}
		}
	}
`;
